import { createContext } from "react";
import { Envs } from "../enums/envs";

type RockyContextType = {
  token: string;
  env: Envs;
};

export const RockyContext = createContext<RockyContextType | undefined>(
  undefined
);
